export const SERVICE_REQUESTS_RESET_STATE = 'SERVICE_REQUESTS_RESET_STATE';
export const SERVICE_REQUESTS_CURRENT_ITEM = 'SERVICE_REQUESTS_CURRENT_ITEM';

export const SERVICE_REQUESTS_REQUEST_LOADING = 'SERVICE_REQUESTS_REQUEST_LOADING';
export const SERVICE_REQUESTS_REQUEST_SUCCESS = 'SERVICE_REQUESTS_REQUEST_SUCCESS';
export const SERVICE_REQUESTS_REQUEST_FAILED = 'SERVICE_REQUESTS_REQUEST_FAILED';

export const SERVICE_REQUESTS_CURRENT_ACTION = 'SERVICE_REQUESTS_CURRENT_ACTION';
export const SERVICE_REQUESTS_RESET_ACTION = 'SERVICE_REQUESTS_RESET_ACTION';
